import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { toast } from 'react-toastify';
import { getAllUsers } from '../../services/teamService';
import ProjectMemberList from './settings/components/ProjectMemberList';
import { updateProject, deleteProject, getProjectById, getMemberRole } from '../../services/projectService';
import FilterProjectRoles from '../../sections/@dashboard/projectDetails/FilterProjectRoles';
import { DeleteModal, Header, ProjectSettingsForm } from './settings/components';
import Loading from '../../layouts/loading';

const ProjectSettingsPage = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [projectDetails, setprojectDetails] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [projectRoles, setProjectRoles] = useState([]);
  const [userRole, setUserRole] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();

  const handleDeleteClick = () => setOpenDelete(true);

  const handleDeleteModalClose = () => setOpenDelete(false);

  const updateProjectDetails = useCallback(
    async (values) => {
      try {
        values.allowOverSpent = !!values.allowOverSpent;
        values.allowManualTask = !!values.allowManualTask;
        const response = await updateProject(id, values);
        toast.success(response?.data?.message);
        setIsEditable(false);
        navigate(`/projects/${projectDetails?.status}`);
      } catch (error) {
        console.log(error?.response?.data?.message);
        if (error?.response?.data?.message === 'Validation error') {
          toast.error(`The project name "${values?.projectName}" already exists. Please choose a different name.`);
        } else {
          toast.error('Oops! Something went wrong while updating the project details. Please try again later.');
        }
      }
    },
    [id, projectDetails?.status, navigate]
  );

  const fetchProjectDetails = async (id) => {
    setLoading(true);
    try {
      const response = await getProjectById(id);
      setprojectDetails(response?.data?.data);

      const employee = await getAllUsers();
      setEmployeeList(employee?.data?.data);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleEditBtn = () => {
    setIsEditable((prev) => !prev);
  };

  const handleDelete = async () => {
    try {
      const Project = await deleteProject(id);
      toast.success(Project?.data?.message);
      navigate(`/projects/${projectDetails?.status}`);
    } catch (error) {
      toast.error('Oops! Something went wrong while deleting the project. Please try again later.');
    }
  };

  useEffect(() => {
    const fetchProjectRoles = async (id, role) => {
      try {
        const roles = await FilterProjectRoles(id, role);
        setProjectRoles(roles);
      } catch (e) {
        toast.error(e.message);
      }
    };

    const projectMemberRole = async () => {
      setLoading(true);
      try {
        const roles = await getMemberRole(id);
        setUserRole(roles.data.data);
        await fetchProjectRoles(id, roles.data.data);
      } catch (e) {
        toast.error(e.message);
      } finally {
        setLoading(false);
      }
    };

    projectMemberRole();

    fetchProjectDetails(id);
  }, [id]);

  return (
    <Container>
      <Loading open={isLoading} />

      <Header
        id={id}
        status={projectDetails?.status}
        name={projectDetails?.projectName}
        userRole={userRole}
        isEditable={isEditable}
        onToggleEditBtn={handleToggleEditBtn}
        onDeleteClick={handleDeleteClick}
      />

      <ProjectSettingsForm isEditable={isEditable} onSubmit={updateProjectDetails} projectDetails={projectDetails}>
        <ProjectMemberList
          isEditable={isEditable}
          projectDetails={projectDetails}
          employeeList={employeeList}
          fetchProjectDetails={fetchProjectDetails}
          setUserRole={setUserRole}
          userRole={userRole}
          projectRoles={projectRoles}
        />
      </ProjectSettingsForm>

      <DeleteModal open={openDelete} onClose={handleDeleteModalClose} onDelete={handleDelete} />
    </Container>
  );
};

export default ProjectSettingsPage;
